import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-refresh-button',
  templateUrl: './refresh-button.component.html',
  styleUrls: ['./refresh-button.component.scss'],
  standalone: false
})
export class RefreshButtonComponent {
  @Input() disabled = false;
  @Output() refresh = new EventEmitter<void>();
}
